import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCalendarCheck",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function h(e, r, d, m, f, a) {
  return i(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--calendar-check"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Calendar Check",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.854 6.646a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708 0Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 3a1.5 1.5 0 0 1 1.5-1.5h1V1a.5.5 0 0 1 1 0v.5h3.003L7.5 1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V3Zm1 0a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1.5H2V3Zm.5 7.5A.5.5 0 0 1 2 10V5.5h8V10a.5.5 0 0 1-.5.5h-7Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const C = /* @__PURE__ */ s(c, [["render", h]]);
export {
  C as default
};
//# sourceMappingURL=calendar-check.js.map
